import ServiceRestrict from 'domains/models/service_restrict';
import { z } from 'zod';
import { RestrictPeriodEnum } from './enum';

export type ServiceRestrictListItem = z.infer<
  typeof schemaServiceRestrictListItem
>;
export const schemaServiceRestrictListItem = z.object({
  serviceId: z.number(),
  teamId: z.number(),
  restrictPeriod: RestrictPeriodEnum,
  value: z.number(),
});

export const toListItem = (
  serviceRestrict: ServiceRestrict,
): ServiceRestrictListItem => {
  return {
    serviceId: serviceRestrict.serviceId,
    teamId: serviceRestrict.teamId,
    restrictPeriod: serviceRestrict.restrictPeriod,
    value: serviceRestrict.value,
  };
};
